import { getEnumValues } from '../enums/get-enum-values';
export enum AppPermission{
	Admin = 'admin',
	EventAdmin = 'event-admin',
	UserAdmin = 'user-admin',
	InstructorAdmin = 'instructor-admin',
	RebuildIndexes = 'RebuildIndexes',
	PaidRole = 'paid-role',
}
export const AppPermissions = getEnumValues<AppPermission>(AppPermission);